import { render, staticRenderFns } from "./analisis_catastrophic_risk_analysis.vue?vue&type=template&id=511e724d"
import script from "./analisis_catastrophic_risk_analysis.vue?vue&type=script&lang=js"
export * from "./analisis_catastrophic_risk_analysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports